const BASE_URL = process.env.NODE_ENV === "production" ? "" : "https://www.p-ban.com"

const HELP_LINKS = {
  構成層数: `${BASE_URL}/link/layer.html`,
  外形寸法: `${BASE_URL}/link/size.html`,
  矩形形状: `${BASE_URL}/link/rectangle.html`,
  メタル材質: `${BASE_URL}/link/metal_material.html`,
  ピン数: `${BASE_URL}/link/pin.html`,
  製造枚数: `${BASE_URL}/link/pcs.html`,
  実装枚数: `${BASE_URL}/link/mount_pcs.html`,
  表面実装部品: `${BASE_URL}/link/others.html`,
  挿入部品: `${BASE_URL}/link/dip.html`,
  実装方法: `${BASE_URL}/link/mount_method.html`,
  マウントデータの支給: `${BASE_URL}/link/mount_data.html`,
  "P板.com無料提供部品": `${BASE_URL}/link/mount_freechips.html`,
  材質: `${BASE_URL}/link/material.html`,
  板厚: `${BASE_URL}/link/board_thickness.html`,
  ベース材厚: `${BASE_URL}/link/base_thickness.html`,
  "ベース／コアの厚み": `${BASE_URL}/link/metal_thickness.html`,
  銅箔厚み: `${BASE_URL}/link/copper_thickness.html`,
  ビルドアップ工法: `${BASE_URL}/link/ivh.html`,
  "最小パターン幅／間隔": `${BASE_URL}/link/line_space.html`,
  "最小ビア径／ランド径": `${BASE_URL}/link/via.html`,
  "レーザービア径／ランド径": `${BASE_URL}/link/laserVia.html`,
  特性インピーダンスコントロール: `${BASE_URL}/link/impedance.html`,
  塗布する面: `${BASE_URL}/link/resist.html`,
  レジスト色: `${BASE_URL}/link/resist_color.html`,
  カバーレイ: `${BASE_URL}/link/coverlay.html`,
  印刷する面: `${BASE_URL}/link/silk.html`,
  シルク印刷色: `${BASE_URL}/link/silk_color.html`,
  シルク印刷工法: `${BASE_URL}/link/silk_print_process.html`,
  表面処理: `${BASE_URL}/link/surface_treatment.html`,
  端子部のみ電解金めっき: `${BASE_URL}/link/gold_slot.html`,
  端子部厚み指定: `${BASE_URL}/link/reinforcement.html`,
  補強板厚み指定: `${BASE_URL}/link/reinforcement.html`,
  面付け数: `${BASE_URL}/link/panel_info.html`,
  FPC面付けされたデータ: `${BASE_URL}/link/FPC_panelization.html`,
  Vカット: `${BASE_URL}/link/vcut.html`,
  ジャンプVカット: `${BASE_URL}/link/jump_vcut.html`,
  ルーター切り出し面付け: `${BASE_URL}/link/router.html`,
  ミシン目面付け: `${BASE_URL}/link/slit.html`,
  データ面付け編集サービス: `${BASE_URL}/link/panelize.html`,
  端面スルーホール: `${BASE_URL}/link/semiTH.html`,
  長穴: `${BASE_URL}/link/longhole.html`,
  "パッド・オン・ビア": `${BASE_URL}/link/pad_on_via.html`,
  "0.3mm未満のパッド": `${BASE_URL}/link/smallpad.html`,
  電磁波シールド: `${BASE_URL}/link/emc_shield.html`,
  ULマーク: `${BASE_URL}/link/UL.html`,
  "AOI検査（外観光学検査）": `${BASE_URL}/link/AOI.html`,
  製造検査成績書: `${BASE_URL}/link/inspection_certificate.html`,
  実装検査成績書: `${BASE_URL}/link/inspection_certificate.html`,
  データ形式: `${BASE_URL}/link/data_form.html`,
  製造工場: `${BASE_URL}/link/manufacture_factory.html`,
  "配置／配線（配線幅・配線長・シールド）ルール": `${BASE_URL}/link/wiring_rules.html`,
  "固有の仕様書・設計指示書": `${BASE_URL}/link/specific_specifications.html`,
  "高電流（10A以上）高電圧（50V以上）多電源（4種以上）": `${BASE_URL}/link/high_voltage_high_current.html`,
  "BGA／CSP": `${BASE_URL}/link/bga_csp.html`,
  "外形が特殊形状・カードエッジコネクタ": `${BASE_URL}/link/special_shape.html`,
  "シルク追加10個以上（部品番号・ピン番除く）": `${BASE_URL}/link/silk_10.html`,
  リジッドフレキ基板: `${BASE_URL}/link/rigid_flex.html`,
  ワイヤーボンディング: `${BASE_URL}/link/wire_bonding.html`,
  "AWデータ支給設計（CAD／LIB必須）": `${BASE_URL}/link/aw_data.html`,
  面付け: `${BASE_URL}/link/panelized.html`,
  "DDR I／F・EMC設計（伝送線路シミュレーション等）": `${BASE_URL}/link/ddr_emc.html`,
  納期短縮対応: `${BASE_URL}/link/design_days_shortening.html`,
  DXFデータ出力: `${BASE_URL}/link/dxf_data_output.html`,
} as const

export default HELP_LINKS
